/** L&D session phases — single URL, switched in LearningFlow as each phase is built. */
export const LEARNING_PHASES = {
  INTRO: 'intro',
  GUIDANCE: 'guidance',
  QUIZ: 'quiz',
  SUCCESS: 'success',
  FAIL: 'fail',
  LOCKED: 'locked',
};
